import { useI18n } from '../i18n';

interface Props {
  page: number;
  pageSize: number;
  total: number | null;
  hasNext: boolean;
  onChange: (page: number) => void;
  busy?: boolean;
}

export function Pagination({ page, pageSize, total, hasNext, onChange, busy }: Props) {
  const { t } = useI18n();
  const totalPages = total !== null && total > 0 ? Math.ceil(total / pageSize) : null;
  if (!hasNext && page === 1) return null;

  return (
    <div className="pagination">
      <button className="btn ghost small" disabled={page <= 1 || busy} onClick={() => onChange(page - 1)}>
        ‹ {t('common.previous')}
      </button>
      <span>{totalPages ? t('common.pageOf', { n: page, total: totalPages }) : t('common.page', { n: page })}</span>
      <button className="btn ghost small" disabled={!hasNext || busy} onClick={() => onChange(page + 1)}>
        {t('common.next')} ›
      </button>
    </div>
  );
}
